$(function() {

    $(".checkout__tab").click(function() {
        $(this).closest(".checkout__tabs").find(".checkout__tab").removeClass("active");
        $(this).addClass("active");
    });
});